import request from "@/utils/request";

//  查询PV
export const getPvCount = data => {
  return request({
    url: "/treasure/statistic/count/getPvCount",
    method: "POST",
    data
  });
};

//  查询UV
export const getUvCount = data => {
  return request({
    url: "/treasure/statistic/count/getUvCount",
    method: "POST",
    data
  });
};

//  查询APP版本以及用户数量
export const getVersion = data => {
  return request({
    url: "/treasure/statistic/count/getVersion",
    method: "POST"
  });
};

//  查询系统版本以及用户数量
export const getSystemVersion = data => {
  return request({
    url: "/treasure/statistic/count/getSystemVersion",
    method: "POST"
  });
};

//  查询装机量和用户数量
export const getUserNum = data => {
  return request({
    url: "/treasure/statistic/count/getUserNum",
    method: "POST"
  });
};
